// extracted by mini-css-extract-plugin
module.exports = {"cert-card":"cert-card_cert-card__3TbxY","description":"cert-card_description__4tXvM"};